// Alpine.js setup and configuration
import Alpine from 'alpinejs';
import mask from '@alpinejs/mask';
import collapse from '@alpinejs/collapse';
// import count from './alpinejs-extra/character-count'

// Setup Alpine plugins
Alpine.plugin(mask);
Alpine.plugin(collapse);

console.log("Alpine.js is set up and started.");

// Alpine.plugin(count);
window.Alpine = Alpine;
